import React from 'react';
import styles from './purchases.module.scss';
import { KoAffix,  KoTabs, KoTitle } from 'packages';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';

const Purchases = () => {
  
  const TABS = [
    {
      key: 'vendors',
      label: <Link to="/paybooks/purchases/vendors">Vendors</Link>,
      children:''
    },
    {
      key: 'expenses',
      label: <Link to="/paybooks/purchases/expenses">Expenses</Link>,
      children:''
    },{
      key: 'recurringexpenses',
      label: <Link to="/paybooks/purchases/recurringexpenses">Recurring Expenses</Link>,
      children:''
    },{
      key: 'purchaseorder',
      label: <Link to="/paybooks/purchases/purchaseorder">Purchase Order</Link>,
      children:''
    },{
      key: 'bills',
      label: <Link to="/paybooks/purchases/bills">Bills</Link>,
      children:''
    },{
      key: 'recurringbills',
      label: <Link to="/paybooks/purchases/recurringbills">Recurring Bills</Link>,
      children:''
    }
  ];

  return (
    <div className={`${styles.wrapper} profileSection`}>
      <KoAffix top={50}>
        <div className={styles.header}>
          <KoTitle text="Purchases" level={4} />
          <KoTabs options={TABS}  />
        </div>
      </KoAffix>
      <Outlet />
    </div>
  );
};

export default Purchases;